if (!customElements.get("variant-picker")) {
	class VariantPicker extends HTMLElement {
		constructor() {
			super();
		}

		get selectedOptionValues() {
			const options = this.querySelectorAll('.m-product-option select, .m-product-option input');
			const selectedValues = new Map();

			options.forEach((field) => {
				const fieldName = field.name || field.dataset.fieldName;

				if (field.tagName.toLowerCase() === "select") {
					const selectedOption = Array.from(field.options).find(
						(opt) => opt.selected && !opt.disabled
					);
					if (selectedOption) {
						selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
					}
				} else if (
					field.tagName.toLowerCase() === "input" &&
					field.type === "radio"
				) {
					const checkedInput = field.checked ? field : null;
					if (checkedInput) {
						selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
					}
				}
			});

			options.forEach((field) => {
				const fieldName = field.name || field.dataset.fieldName;

				if (!selectedValues.has(fieldName)) {
					if (field.tagName.toLowerCase() === "select") {
						const firstValidOption = Array.from(field.options).find(
							(opt) => !opt.disabled
						);
						if (firstValidOption) {
							selectedValues.set(
								fieldName,
								firstValidOption.dataset.optionValueId
							);
						}
					} else if (
						field.tagName.toLowerCase() === "input" &&
						field.type === "radio"
					) {
						const firstInput = field;
						if (firstInput) {
							selectedValues.set(fieldName, firstInput.dataset.optionValueId);
						}
					}
				}
			});

			const result = [];
			options.forEach((field) => {
				const fieldName = field.name || field.dataset.fieldName;
				if (selectedValues.has(fieldName)) {
					const optionValueId = selectedValues.get(fieldName);
					if (optionValueId && !result.includes(optionValueId)) {
						result.push(optionValueId);
					}
				}
			});
			return result;
		}

		toHandle(str) {
			return str
				.toLowerCase()
				.replace(/[^\w\s-]/g, '')
				.replace(/[\s_]+/g, '-') 
				.replace(/^-+|-+$/g, '') 
				.replace(/--+/g, '-')    
				.replace(/-/g, '');      
		}

		getCurrentVariantTitle() {
			const selectedOptions = [];
			const options = this.querySelectorAll('.m-product-option select, .m-product-option input:checked');
			
			options.forEach(option => {
				if (option.tagName.toLowerCase() === 'select') {
					const selectedOption = option.options[option.selectedIndex];
					if (selectedOption) {
						const optionValue = selectedOption.value || selectedOption.getAttribute('value');
						if (optionValue) {
							selectedOptions.push(optionValue);
						}
					}
				} else if (option.type === 'radio' && option.checked) {
					const optionValue = option.value || option.getAttribute('value');
					if (optionValue) {
						selectedOptions.push(optionValue);
					}
				}
			});
			
			const variantTitle = selectedOptions.join(' / ');
			return variantTitle;
		}

		updateIngredientDivs(variantTitle) {
			const variantHandle = this.toHandle(variantTitle);
			const allCustomDivs = document.querySelectorAll('.custom-variant-ingredients');
			allCustomDivs.forEach(div => {
				div.style.display = 'none';
			});
			const specificVariantDiv = document.querySelector('.variant-' + `${variantHandle}`);
			if (specificVariantDiv) {
				specificVariantDiv.style.display = 'block';
				
				const mainIngredientDiv = document.querySelector('.main-product-ingredients');
				if (mainIngredientDiv) {
					mainIngredientDiv.style.display = 'none';
				}
			} else {
				const mainIngredientDiv = document.querySelector('.main-product-ingredients');
				if (mainIngredientDiv) {
					mainIngredientDiv.style.display = 'block';
				}
			}
		}

		connectedCallback() {
			this.addEventListener('change', (event) => {
				const target = this.getInputForEventTarget(event.target);
				const selectedOptionValues = this.selectedOptionValues;
				
				const currentVariantTitle = this.getCurrentVariantTitle();
				this.updateIngredientDivs(currentVariantTitle);
				
				MinimogEvents.emit(MinimogTheme.pubSubEvents.optionValueSelectionChange, { 
					data: { 
						selectedOptionValues: selectedOptionValues, 
						event, 
						target,
						variantTitle: currentVariantTitle
					} 
				});
			});

			const initialVariantTitle = this.getCurrentVariantTitle();
			if (initialVariantTitle) {
				this.updateIngredientDivs(initialVariantTitle);
			}
		}

		getInputForEventTarget(target) {
			return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
		}
	}
	customElements.define("variant-picker", VariantPicker);
}